import React from 'react';
import { urlApi } from '../Constants/Global';

import SectionHeader from '../Components/SectionHeader';
import Bg from '../Medias/Photos/photo-bg7.jpg';
import SectionNews from '../Components/SectionNews';

const NewsAndEvents = ({ contents }) => {
  console.log(contents)

  return (
    <>
      <SectionHeader topic='News & Events' detail='Stay updated with our firm’s latest activities, legal seminars, and community engagements.' bg={Bg} />
      <section className='mt-5 mb-5 pb-5'>
        <SectionNews hideTopic={true} />
      </section>
    </>
  )
}

NewsAndEvents.defaultProps = {
  contents: {
    lang: 'th',
    content: {
      contents: []
    }
  },
  web_setup: {
    practice_topic: [],
    practice: []
  },
  path: '',
  lang: 'en'
}

export default NewsAndEvents